import classes from "./AboutDiavouleuseis.module.css";
import HeaderImage from "../assets/images/talk.png";
import espa from "../assets/images/espa.png";
import { Link } from "react-router-dom/cjs/react-router-dom";

const AboutDiavouleuseis = () => {
  return (
    <div className={`${classes.container}`}>
      <div style={{ position: "relative" }}>
        <div className={`${classes.headerImageWrapper}`}>
          <img
            src={HeaderImage}
            alt="Diavouleuseis"
            className={`${classes.headerImage}`}
          />
        </div>
        <h3 className={`${classes.headerTitle}`}>Πληροφορίες για το έργο</h3>
      </div>
      <div className={`${classes.section}`}>
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <span
            style={{
              width: "400px",
              height: "40px",
              backgroundColor: "#E5BAB84f",
              position: "absolute",
              top: "10px",
              left: "10px",
            }}
          ></span>
          <p className={`${classes.contentTitle}`}>Τι είναι το έργο </p>
          <Link
            style={{ color: "#E5BAB8", fontWeight: "600" }}
            to="/diavouleuseis"
          >
            Επιστροφή
          </Link>
        </div>
        <p className={`${classes.indentedText}`}>
          Το έργο στοχεύει στην ορθολογική διαχείριση κρίσιμων τομέων παροχής
          υπηρεσιών από τον Δήμο Νικολάου Σκουφά όπως (ενδεικτική αναφορά
          επιλέξιμων δράσεων): η ενεργειακή διαχείριση κτιρίων και δικτύων
          ηλεκτρικού ρεύματος, η διαχείριση απορριμμάτων, η παρακολούθηση του
          προϋπολογισμού του Δήμου, οι ηλεκτρονικές υπηρεσίες προς τους δημότες,
          η διαχείριση του δικτύου πόσιμου ύδατος και η λειτουργία του
          μηχανισμού διαχείρισης εργοταξίων. Επιπλέον, η πρόταση περιλαμβάνει
          και την προμήθεια εξοπλισμού για την ελεύθερη πρόσβαση των δημοτών και
          των επισκεπτών σε ένα μικρής κλίμακας ασύρματο δίκτυο σε δέκα (10)
          σημεία συγκέντρωσης πληθυσμού (public hot spot).
        </p>
        <p className={`${classes.indentedText}`}>
          Ο Δήμος Σκουφά με τις λύσεις της εταιρείας DOTSOFT διαθέτει ένα
          ολοκληρωμένο σύστημα για:
        </p>
        <ol style={{ marginTop: 0 }}>
          <li>
            την παρακολούθηση και τη διαχείριση της κατανάλωσης ρεύματος σε
            δημόσια κτίρια με την χρήση κατάλληλων αισθητήρων στους πίνακες τους
          </li>
          <li>
            την παρακολούθηση και τη διαχείριση των λογαριασμών κατανάλωσης
            ρεύματος για όλες τις παροχές του Δήμου για την αποφυγή
            ρευματοκλοπών
          </li>
          <li>
            τον έλεγχο της πληρότητας των κάδων που βρίσκονται σε απομακρυσμένες
            περιοχές και σε πολυσύχναστα σημεία όπως σχολεία, δημόσια κτίρια,
            ΚΑΠΗ, εκκλησίες, αγροτικά ιατρεία κτλ.
          </li>
          <li>
            τον έλεγχο της κίνησης των απορριμματοφόρων, των οχημάτων πολιτικής
            προστασίας καθώς και των οχημάτων εργοταξιακών εργασιών με χρήση
            προηγμένου συστήματος παρακολούθησης και διαχείρισης στόλου
          </li>
          <li>
            την συνεχή παρακολούθηση της εκτέλεσης του προϋπολογισμού του Δήμου
            ώστε να διευκολύνει την λήψη αποφάσεων κατά τη διάρκεια του έτους
          </li>
          <li>
            τη συμμετοχή των πολιτών σε καθημερινά ζητήματα του Δήμου κάνοντας
            χρήση της προτεινόμενης ηλεκτρονικής πλατφόρμας διαβούλευσης και
            συμμετοχικού προϋπολογισμού καθώς και της εφαρμογής (native) μέσω
            κινητών τηλεφώνων για την αναγγελία βλαβών, καταγραφή προβλημάτων
            καθημερινότητας αλλά και παρακολούθησης της εξέλιξης αυτών από τις
            αντίστοιχες αντιδημαρχίες
          </li>
          <li>
            η διαχείριση των Υδρομέτρων (Υ/Μ) στα όρια του Δήμου. Η εφαρμογή
            διαχειρίζεται το μητρώο Υδρομέτρων του Δήμου και παρέχει πρόσβαση με
            χρήση ονόματος χρήστη και κωδικού πρόσβασης στο μητρώο παροχών
            ύδρευσης του Δήμου. Ταυτόχρονα η εφαρμογή με χρήση ελεύθερου
            λογισμικού, λογισμικού ανοικτού κώδικα (ΕΛ/ΛΑΚ) προσφέρει την
            καταγραφή και την κωδικοποίηση των παροχών ύδρευσης στη γεωγραφική
            έκταση του Δήμου (με χρήση εφαρμογής για τα κινητά τηλέφωνα του
            προσωπικού που υδρομετρεί) σε συνδυασμό με την επεξεργασία των
            δεδομένων καταγραφής και τη δημιουργία αρχείου για την εισαγωγή στο
            λογισμικό οικονομικής διαχείρισης του Δήμου
          </li>
          <li>
            την ελεύθερη πρόσβαση των δημοτών και των επισκεπτών στο ασύρματο
            δίκτυο (WiFi) που θα δημιουργηθεί σε δέκα (10) σημεία (πλατείες)
            εντός των ορίων του Δήμου
          </li>
        </ol>
        <p className={`${classes.indentedText}`}>
          Με τις εφαρμογές έξυπνης πόλης, ο Δήμος Νικολάου Σκουφά αξιοποιεί
          πλήρως τις τεχνολογίες πληροφορικής και επικοινωνιών για τον έλεγχο
          και τη βελτίωση της ποιότητας των παρεχόμενων υπηρεσιών προς τους
          δημότες του, τη μείωση του λειτουργικού κόστους στους τομείς
          ηλεκτρικής ενέργειας, των απορριμμάτων και του μηχανισμού διαχείρισης
          εργοταξίων αλλά και την αποτελεσματική διαχείριση κρίσεων στα όρια του
          Δήμου.
        </p>
        <div>
          <p className={`${classes.indentedText}`}>
            Το έργο εντάσσεται στο Επιχειρησιακό Πρόγραμμα “Ήπειρος 2014-2020”
          </p>
          <p className={`${classes.indentedText}`}>
            Με την συγχρηματοδότηση της Ελλάδας και της Ευρωπαϊκής Ένωσης
          </p>
        </div>
      </div>
      <img src={espa} alt="espa" />
    </div>
  );
};

export default AboutDiavouleuseis;
